import { render, staticRenderFns } from "./HubContactDetails.vue?vue&type=template&id=8930ee38&"
import script from "./HubContactDetails.vue?vue&type=script&lang=js&"
export * from "./HubContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./HubContactDetails.vue?vue&type=style&index=0&id=8930ee38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports